var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { action, observable } from 'mobx';
import CollaboratorStretch from './CollaboratorStretch';
import { api } from '../../helpers/Api';
export default class CollaboratorStretchesStore {
    constructor() {
        this.loaded = false;
        this.services = [];
        this.read = (value) => {
            if (value) {
                return api.post(`collaborators/services/operator`, value)
                    .then(collaboartorStretch => {
                    return collaboartorStretch ? new CollaboratorStretch(collaboartorStretch) : null;
                });
            }
            return api.get(`collaborators/services`).then(this.setServices);
        };
        this.setServices = value => {
            // console.log('CollaboratorStretchesStore - setServices - value: ', value)
            if (value) {
                this.services = value.map(service => new CollaboratorStretch(service));
                // PersistenciaStore.setServicesCollaboratorStretches(this.services)
            }
            this.loaded = true;
            return this.services;
        };
        this.setData = (data) => {
            this.setServices(data);
        };
    }
}
__decorate([
    observable
], CollaboratorStretchesStore.prototype, "loaded", void 0);
__decorate([
    observable
], CollaboratorStretchesStore.prototype, "service", void 0);
__decorate([
    observable
], CollaboratorStretchesStore.prototype, "services", void 0);
__decorate([
    action
], CollaboratorStretchesStore.prototype, "setServices", void 0);
__decorate([
    action
], CollaboratorStretchesStore.prototype, "setData", void 0);



//////////////////
// WEBPACK FOOTER
// ./src/modules/CollaboratorStretches/CollaboratorStretchesStore.ts
// module id = 573
// module chunks = 0